import api from "../api";
export default {

  getQualtricsProgress({ params }) {
    return api.get(`qualtrics/`, { params });
  },

};
